export function redirectAdoptionAgentToRiskAdvisor (to) {
    return {
        name: 'RiskAdvisor',
        params: to.params,
        query: to.query,
        hash: to.hash,
    };
}
